<template>
    <span>
        <a
            class="button interactive"
            :class="buttonClasses"
            @click="handleClick()"
            v-if="shouldShow"
        >
            {{ label }}
        </a>
        <div class="inner" v-if="showLoginDropDown">
            <ul class="listing shortlists shortlists--custom">
                <li class="shortlist-action" @click="showLogin">
                    <svg-icon id="signIn"></svg-icon>
                    <span>Log In </span>
                </li>
                <li class="shortlist-action" @click="showSignup">
                    <svg-icon id="signUp"></svg-icon>
                    <span>Sign Up For Free</span>
                </li>
            </ul>
        </div>
    </span>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: false,
            default: " Brief Us",
        },
        buttonClasses: {
            type: String,
            required: false,
            default: "outline-black",
        },
    },
    data() {
        return {
            showLoginDropDown: false,
            triggeredAuth: false,
        };
    },
    mounted() {
        window.addEventListener("click", this.delegatedHideBriefUs);
    },
    beforeDestroy() {
        window.removeEventListener("click", this.delegatedHideBriefUs);
    },
    methods: {
        handleClick() {
            if (this.$store.getters["user/account"]) {
                this.$store.commit('findspace/navigateToSubpage', { page: 'briefs', subpage: 'create' })
            } else {
                this.$store.commit("findspace/show");
            }
        },
        showLogin() {
            this.triggeredAuth = true;
            this.$store.commit("user/changeAuthMode", "login");
        },
        showSignup() {
            this.triggeredAuth = true;
            this.$store.commit("user/changeAuthMode", "signup");
        },
        showAction() {
            this.showLoginDropDown = !this.showLoginDropDown;
        },
        delegatedHideBriefUs(e) {
            let target = e.target;

            while (target.parentNode) {
                if (target === this.$el) {
                    return;
                }

                target = target.parentNode;
            }

            this.showLoginDropDown = false;
        },
    },
    computed: {
        authenticating() {},
        shouldShow() {
            return (
                !this.$store.getters["user/account"] ||
                (this.$store.getters["user/isHirer"] &&
                    !this.$store.getters["user/shouldCompleteProfile"])
            );
        },
        isLoggedIn() {
            var loggedInObj = this.$store.getters["user/account"];
            this.showLoginDropDown =
                typeof loggedInObj === "object"
                    ? false
                    : this.showLoginDropDown;
            return loggedInObj;
        },
    },
    watch: {
        authenticating(now) {
            if (!now && this.triggeredAuth && !this.isLoggedIn) {
                this.triggeredAuth = false;
            }
        },
        isLoggedIn(now) {
            if (now && this.triggeredAuth) {
                this.$store.commit("account/hide");
                this.triggeredAuth = false;
                this.showLoginDropDown = false;
            }
        },
    },
};
</script>
